module.exports = __webpack_public_path__ + "static/media/sad-feedback.1e196ca8.png";